import React from 'react';

function SuccessMsg() {
  return (
    <div className='SuccessMsg'>
          <p>Logged-In <br/>Successfully</p>
    </div>
  )
}

export default SuccessMsg